import { useEffect, useState } from "react";
import { getComparisonScoringConfigBackupByRule } from "../services/scoringService";

const useFetchComparisonScoringConfigBackup = ({
  ruleId,
  setIsLoading,
  page,
  pSize,
}: any) => {
  const [backupData, setBackupData] = useState<any>([]);
  useEffect(() => {
    if (ruleId && ruleId > 0) {
      setIsLoading(true);
      const fetchData = async () => {
        try {
          const result = await getComparisonScoringConfigBackupByRule({
            ruleId,
            page,
            pSize,
          });
          setBackupData(result);
        } catch (err) {
          setBackupData([]);
        } finally {
          setIsLoading(false);
        }
      };
      fetchData();
    }
  }, [ruleId, page, pSize]);

  return [backupData];
};

export default useFetchComparisonScoringConfigBackup;

